module.exports = __webpack_public_path__ + "static/media/Saqib.336c2e82.jpeg";